module.exports = __webpack_public_path__ + "img/toolkit_cover_background.f9b982ee.png";